export default __webpack_public_path__ + "static/media/ZZC_7841.f20a44fa.jpg";